import * as React from 'react';
import { LinkProps as RouterLinkProps } from 'react-router-dom';

type AnchorProps = {
  element: 'a';
  href: string;
  getRef?: React.MutableRefObject<HTMLAnchorElement | null>;
} & Omit<React.HTMLProps<HTMLAnchorElement>, 'size'>;

type LinkProps = {
  element: 'link';
  getRef?: React.MutableRefObject<HTMLAnchorElement | null>;
} & RouterLinkProps;

type ButtonProps = {
  element: 'button';
  getRef?: React.MutableRefObject<HTMLButtonElement | null>;
} & Omit<React.HTMLProps<HTMLButtonElement>, 'value' | 'size'>;

type DivProps = {
  element: 'div';
  getRef?: React.MutableRefObject<HTMLDivElement | null>;
} & Omit<React.HTMLProps<HTMLDivElement>, 'value' | 'size'>;

type Common = {
  element?: string;
  getRef?: React.MutableRefObject<HTMLElement | null>;
} & Omit<React.HTMLProps<HTMLElement>, 'value' | 'size'>;

type ElementSpecificProps = Common | AnchorProps | LinkProps | ButtonProps | DivProps;

export type ValueProp = string | number | boolean | Record<string, any>;

export type ClickedProps<V extends ValueProp> = {
  value?: V;
  onClickWithValue?: (value: V) => void;
  onClick?: (e: React.MouseEvent) => void;
} & ElementSpecificProps;

export const isAnchorProps = (props: ElementSpecificProps): props is AnchorProps => props.element === 'a';

export const isLinkProps = (props: ElementSpecificProps): props is LinkProps => props.element === 'link';

export const isButtonProps = (props: ElementSpecificProps): props is ButtonProps => props.element === 'button';

export const isDivProps = (props: ElementSpecificProps): props is DivProps => props.element === 'div';
